/** if you want to use console.log in your code permanently, use this function instead of console.log
 * if you want to use console.log in your code temporarily, use console.log so eslint rule can catch it
 * if forgotten to be removed
 * */
export function consoleLog(...args: any[]) {
  // eslint-disable-next-line no-console
  console.log(...args);
}
